import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import Button from "../../stories/Button/Button";
import FeaturedCollectionCard from "../../stories/FeaturedCollectionCard";
import Footer from "../../stories/Footer";
import Header from "../../stories/Header";
import Input from "../../stories/Input";
import MainCard from "../../stories/MainCard";
import TextArea from "../../stories/TextArea";

function Demo() {
  return (
    <Row>
      <Col md={12}>
        <Header bgTransparent={false} />
        <Footer />
        {/* <Input placeholder={'aaaa'} /> */}
        {/* <TextArea placeholder={'aaaa'} rows={10} /> */}
        {/* <Button label={'aaaa'} primary={true} /> */}
        {/* <MainCard /> */}
        {/* <FeaturedCollectionCard /> */}
        {/* <Featu */}
      </Col>
    </Row>
  );
}

export default Demo;
